import React from 'react';
import actions from '../actions/TransInformationAction.js';
import TransInformationStore from '../stores/TransInformationStore.js';
import { withRouter } from 'react-router-dom';

var trstyle = {
    float: 'right',
    margin: '10px 15px 0px 0px'
}
class EnterOtp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Mobile: '',
            MobileInfo: [],
        };
        this.getotpDetails = this.getotpDetails.bind(this);
    }

    getotpDetails() {
        var MobileInfo = TransInformationStore.getotpDetails()
        this.setState({ MobileInfo: TransInformationStore.getotpDetails() });
        if (typeof MobileInfo === 'object') {
            if (MobileInfo.Type.toLowerCase() === 'success') {
                console.log("Login successfull");
                alert("OTP Varified successfull")
                this.props.history.push('/AfterOTPChangePass')
            }
            else {
                alert("Incorrect OTP, Please Try Again.")
            }
        }
        else {
            if (MobileInfo.indexOf('undefined') > 0) {
                console.log("Mobile varified Unsuccessful");
                alert("Incorrect OTP, Please Try Correct OTP")
                this.props.history.push('/Login')
            }
        }
    }

    componentWillMount() {
        TransInformationStore.addListener('getVerifyOTPInfo', this.getotpDetails)
    }

    componentWillUnmount() {
        TransInformationStore.removeListener('getVerifyOTPInfo', this.getotpDetails)
    }

    SubmitOTP(e) {
        e.preventDefault();
        actions.SubmitOTP(this.state);
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        return (
            <div class="pages">
                <div data-page="form" class="page no-toolbar no-navbar">
                    <div class="page-content">
                        <div class="navbarpages navbarpagesbg">
                            <div class="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <div class="page_single layout_fullwidth_padding">
                                <div class="contactform">
                                    <form class="" id="CustomForm" method="post" action="">
                                        <div class="form_row">
                                            <label htmlFor="OTP"> OTP टाका  :</label>
                                            <input type="Number" class="form_input" id="OTP" name="OTP" value={this.state.OTP} onChange
                                                ={(e) => this.handleInputChange(e)} placeholder="OTP टाका" />
                                        </div>
                                        <div className="col-10">
                                            <button type="submit" style={trstyle} class="btn  btn-primary" onClick={(e) => this.SubmitOTP(e)}>Submit OTP </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(EnterOtp)





// WEBPACK FOOTER //
// ./src/component/EnterOtp.jsx